import {API_VERSION} from '@/utils/constants/commonConstants';
import {HTTP_METHODS} from '@/utils/constants/httpMethods';
import {buildQueryParams} from '@/utils/commons';

export const PERFECT_STORE_CONFIG = {
  ADD_DRAFT_PERFECT_STORE: {
    endPoint: 'perfect-store-targets',
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1
  },
  UPDATE_DRAFT_PERFECT_STORE: {
    endPoint: 'perfect-store-targets',
    method: HTTP_METHODS.PUT,
    version: API_VERSION.V1
  },
  PUBLISH_PERFECT_STORE: {
    endPoint: 'perfect-store-targets',
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1
  },
  UPDATE_PERFECT_STORE: {
    endPoint: 'perfect-store-targets',
    method: HTTP_METHODS.PUT,
    version: API_VERSION.V1
  },
  VALIDATE_PERFECT_STORE_NAME: {
    endPoint: 'perfect-store-targets/validate-name',
    method: HTTP_METHODS.GET,
    appendQueryParams: true
  },
  PERFECT_STORE_LIST: (queryParams) => ({
    endPoint: `perfect-store-targets/list?${buildQueryParams(queryParams)}`,
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1
  }),
  PERFECT_STORE_DOWNLOAD: (queryParams) => {
    const query = queryParams ? `?${buildQueryParams(queryParams)}` : '';
    return {
      endPoint: `perfect-store-targets/download${query}`,
      method: HTTP_METHODS.POST,
      version: API_VERSION.V1
    };
  },
  GET_PERFECT_STORE_DETAIL: (id) => ({
    endPoint: `perfect-store-targets/${encodeURIComponent(id)}`,
    method: HTTP_METHODS.GET,
    version: API_VERSION.V1
  }),
  IMPORT_FIRST_POSITION_TARGET_FILE: (id) => ({
    endPoint: `first-position-targets/${encodeURIComponent(id)}/import-file`,
    method: HTTP_METHODS.PUT,
    version: API_VERSION.V1
  }),
  GET_VISIT_STATUS_TEMPLATE: (targetId) => ({
    endPoint: `template/visit-status?perfectStoreTargetId=${encodeURIComponent(targetId)}`,
    method: HTTP_METHODS.GET,
    version: API_VERSION.V1
  }),
  UPDATE_STORE_VISITS_TEMPLATE: (targetId) => ({
    endPoint: `perfect-store-targets/${encodeURIComponent(targetId)}/update-target-template`,
    method: HTTP_METHODS.PUT,
    version: API_VERSION.V1
  }),
  GET_VISIT_LIST: (targetId, queryParams) => ({
    endPoint: `perfect-store-targets/${encodeURIComponent(targetId)}/visit-list?${buildQueryParams(queryParams)}`,
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1
  }),
  DOWNLOAD_PERFECT_STORE_REPORT: (targetId) => ({
    endPoint: `perfect-store-targets/download-report?targetId=${encodeURIComponent(targetId)}`,
    method: HTTP_METHODS.GET,
    version: API_VERSION.V1
  })
};
